<template>
  <div>
    <!-- Address Suggestion Modal Button -->
    <button ref="addressSuggestion" type="button" class="btn btn-primary d-none" data-toggle="modal"
      data-target="#addressSuggestionModal"></button>

    <!-- Address Suggestion Modal -->
    <div class="modal fade" id="addressSuggestionModal" tabindex="-1" role="dialog" aria-labelledby="ModalLabel"
      aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">
              {{ $resourceString["checkout.AddressVerification.Modal.Title"] }}
            </h5>
            <button class="wf-modal-button-close btn button-full" type="button" data-dismiss="modal"
              ref="closeAddressSuggestion">
              <span class="png-icon png-icon-icons-symbols--k-txtclose" aria-label="Close modal" />
            </button>
          </div>
          <div class="modal-body">
            <div class="small mb-4 align-top text-muted font-weight-light mark p-2" v-html="$resourceString['checkout.AddressVerification.Modal.SubTitle']
              "></div>
            <div class="form-group small fw-light">
              <div class="custom-control custom-radio small bg-light p-4 mb-3">
                <input type="radio" id="customRadio1" name="customRadio" class="custom-control-input"
                  v-model="checkBoxAddress" value="currentAddress" />
                <label class="custom-control-label text-uppercase" for="customRadio1">
                  {{
                    $resourceString[
                    "checkout.AddressVerification.Modal.EnteredAddress.Label"
                    ]
                  }}
                </label>
                <br />
                <div class="m-0">
                  {{ checkoutData.FirstName }} {{ checkoutData.LastName }}
                </div>
                <div class="m-0">{{ checkoutData.AddressLine1 }}</div>
                <div class="m-0">
                  {{ checkoutData.City }} {{ checkoutData.State }}
                  {{ checkoutData.PostalCode }}
                </div>
                <div class="m-0">{{ checkoutData.Country }}</div>
              </div>
              <div class="custom-control custom-radio small bg-light p-4 mb-3" v-if="checkoutData.ChangedAddress">
                <input type="radio" id="customRadio2" name="customRadio" class="custom-control-input"
                  v-model="checkBoxAddress" value="suggestedAddress" />
                <label class="custom-control-label text-uppercase" for="customRadio2">
                  {{
                    $resourceString[
                    "checkout.AddressVerification.Modal.ChangedAddress.Label"
                    ]
                  }}
                </label>
                <div class="mb-1">
                  {{ checkoutData.FirstName }} {{ checkoutData.LastName }}
                </div>
                <div class="mb-1" :class="checkoutData.AddressLine1 !=
                    checkoutData.ChangedAddress.AddressLine1
                    ? 'changed-address'
                    : ''
                  ">
                  {{ checkoutData.ChangedAddress.AddressLine1 }}
                </div>
                <div class="mb-1">
                  <span :class="checkoutData.City != checkoutData.ChangedAddress.Locality
                      ? 'changed-address'
                      : ''
                    ">
                    {{ checkoutData.ChangedAddress.Locality }}
                  </span>
                  <span :class="checkoutData.State !=
                      checkoutData.ChangedAddress.AdministrativeArea
                      ? 'changed-address'
                      : ''
                    ">
                    {{ checkoutData.ChangedAddress.AdministrativeArea }}
                  </span>
                  <span :class="checkoutData.PostalCode !=
                      checkoutData.ChangedAddress.PostalCode
                      ? 'changed-address'
                      : ''
                    ">
                    {{ checkoutData.ChangedAddress.PostalCode }}
                  </span>
                </div>
                <div class="m-0">
                  <span :class="checkoutData.Country !=
                      checkoutData.ChangedAddress.Country
                      ? 'changed-address'
                      : ''
                    ">
                    {{ checkoutData.ChangedAddress.Country }}
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer d-flex justify-content-around">
            <button type="button" class="btn btn-primary" @click="submitFormFromModel(true)">
              {{
                $resourceString[
                "checkout.AddressVerification.Modal.ContinueButton"
                ]
              }}
            </button>
            <button type="button" class="btn btn-outline-primary" @click="submitFormFromModel(false)">
              {{
                $resourceString["checkout.AddressVerification.Modal.EditButton"]
              }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Address Suggestion Modal Button -->
    <button ref="addressMelissa" type="button" class="btn btn-primary d-none" data-toggle="modal"
      data-target="#addressMelissaModal"></button>

    <!-- Address Suggestion Modal -->
    <div class="modal fade" id="addressMelissaModal" tabindex="-1" role="dialog" aria-labelledby="ModalLabel"
      aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="addressMelissaModalLabel">
              {{ $resourceString["checkout.AddressVerification.Modal.Title"] }}
            </h5>
            <button class="wf-modal-button-close btn button-full" type="button" data-dismiss="modal"
              ref="closeAddressMelica">
              <span class="png-icon png-icon-icons-symbols--k-txtclose" aria-label="Close modal" />
            </button>
          </div>
          <div class="modal-body">
            <div class="small mb-4 align-top text-muted font-weight-light mark p-2">
              {{
                $resourceString[
                "checkout.AddressVerification.InvalidMelica.Modal.SubTitle"
                ]
              }}
            </div>
            <div class="form-group small fw-light">
              <div class="custom-control custom-radio small bg-light p-4 mb-3" v-if="
                checkoutData.IsAddressNotPresizeOnMelissa &&
                checkoutData.ChangedAddress == null
              ">
                <input type="radio" id="customRadio3" name="customRadio" class="custom-control-input"
                  v-model="checkBoxAddress" value="currentAddress" />
                <label class="custom-control-label text-uppercase" for="customRadio3">
                  {{
                    $resourceString[
                    "checkout.AddressVerification.Modal.EnteredAddress.Label"
                    ]
                  }}
                </label>
                <br />
                <div class="m-0">
                  {{ checkoutData.FirstName }} {{ checkoutData.LastName }}
                </div>
                <div class="m-0">{{ checkoutData.AddressLine1 }}</div>
                <div class="m-0">
                  {{ checkoutData.City }} {{ checkoutData.State }}
                  {{ checkoutData.PostalCode }}
                </div>
                <div class="m-0">{{ checkoutData.Country }}</div>
              </div>
            </div>
          </div>
          <div class="modal-footer d-flex justify-content-around">
            <button type="button" class="btn btn-primary" @click="submitFormFromModel(true)">
              {{
                $resourceString[
                "checkout.AddressVerification.Modal.ContinueButton"
                ]
              }}
            </button>
            <button type="button" class="btn btn-outline-primary" @click="submitFormFromModel(false)">
              {{
                $resourceString["checkout.AddressVerification.Modal.EditButton"]
              }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
  data() {
    return {
      checkBoxAddress: "currentAddress"
    };
  },
  computed: {
    ...mapGetters({
      checkoutData: "newCheckoutPage/checkoutData"
    })
  },
  watch: {
    checkoutData(newValue, OldValue) {
      if (newValue.ChangedAddress !== null) {
        this.$refs.addressSuggestion.click();
      }
      if (newValue.IsAddressNotPresizeOnMelissa && newValue.ChangedAddress === null) {
        this.$refs.addressMelissa.click();
      }
    }
  },
  methods: {
    ...mapActions({
      updateRedirectWithSelectedAddress: "newCheckoutPage/updateRedirectWithSelectedAddress",
      checkoutSubmit: "newCheckoutPage/checkoutSubmit",
      updateCurrentAddress: "newCheckoutPage/updateCurrentAddress",
      openEditAddressModal: "newCheckoutPage/openEditAddressModal"
    }),
    submitFormFromModel(continueWithSelected) {
      if (this.checkBoxAddress == null) {
        this.checkBoxAddress = "currentAddress";
      }
      if (this.checkBoxAddress == "suggestedAddress") {
        this.updateCurrentAddress();
      }
      if (!continueWithSelected) {
        this.$refs.closeAddressSuggestion.click();
        this.$refs.closeAddressMelica.click();
        this.openEditAddressModal();
        return;
      }

      this.$refs.closeAddressSuggestion.click();
      this.$refs.closeAddressMelica.click();
      this.updateRedirectWithSelectedAddress(continueWithSelected);
      this.checkoutSubmit();
    }
  }
};
</script>
